import {FrequentlyAskedQuestion} from '../../frequently-asked-questions/frequently-asked-question/frequently-asked-question';

export class FrequentlyAskedQuestionAnswer {
  answer: string;
  frequentlyAskedQuestion: FrequentlyAskedQuestion;
  id: string;
}
